const miniHowItWorksStyle = {
  section_wrapper: `w-full py-12 px-6 flex flex-col items-center justify-center relative overflow-hidden -mt-0 screen-500:-mt-6 sm:-mt-5 lg:-mt-7 -mb-0 screen-500:-mb-6 sm:-mb-5 lg:-mb-7
                    screen-500:py-16
                    md:py-20 md:px-8
                    lg:py-24`,
  header_wrpr: `flex items-center justify-center gap-4 w-full mb-12 md:mb-16 select-none`,
  list_container: `flex flex-col gap-6 md:gap-8 max-w-[650px] md:max-w-[800px] w-full mx-auto px-2 md:px-4`,
  step_row: `flex items-start gap-5 md:gap-8 justify-start`,
  number: `text-liveGamePrimaryColor font-Suisse font-[900] italic text-[36px] leading-[50px] md:text-[48px] md:leading-[55px] min-w-[50px] md:min-w-[70px] select-none`,
  text: `text-white font-Suisse font-[400] text-[14px] leading-[20px] screen-500:text-[16px] screen-500:leading-[24px] md:text-[18px] md:leading-[28px]`,
};

export { miniHowItWorksStyle };
